import { Table } from 'antd';
import React, { ReactNode } from 'react';
import { ModalConfirmation } from '..';
import { buildColumn, ScrollType } from '../../../Helper';
import styles from './modalConfirmationList.module.scss';

type Props<T> = {
	type?: string;
	translationKey?: string;
	customContent?: ReactNode;
	data: { Name: string }[];
	footer?: React.ReactElement;
	width?: string;
	onConfirm?: (value: T) => void;
	onCancel?: (value: T) => void;
};

//Avoid creating object style inline, since increases reconciliations
const scroll: ScrollType = { y: 272 };

const ModalConfirmationList = <T extends object | string | number>({
	data,
	type,
	translationKey,
	customContent,
	footer,
	width,
	onCancel,
	onConfirm,
}: Props<T>) => {
	const columns: any[] = [
		{
			...buildColumn(_('Name'), 'Name', '100px', 'start'),
		},
	];
	const dataSource = data.map((x, index) => ({ ...x, key: index }));

	const key: string = translationKey === undefined ? 'AreYouSureYouWantToDeleteTheFollowing' : translationKey;

	return ModalConfirmation({
		onConfirm,
		onCancel,
		width: width,
		content: (
			<div className={styles.container}>
				{customContent ? customContent : <span>{_(key).replace('%1', type)}</span>}
				<br />
				<Table
					scroll={dataSource.length ? scroll : undefined}
					size='small'
					columns={columns}
					dataSource={dataSource}
					className={styles.statusWidgetTable}
					pagination={false}
				/>
				{footer}
			</div>
		),
	});
};

export { ModalConfirmationList };
